import React from "react";

const MailIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 27C36 29.209 34.209 31 32 31H4C1.791 31 0 29.209 0 27V9C0 6.791 1.791 5 4 5H32C34.209 5 36 6.791 36 9V27Z"
        fill="#CCD6DD"
      />
      <path
        d="M11.9492 17.636L0.636172 28.949C0.609172 28.977 0.599172 29.012 0.576172 29.04C0.916172 29.61 1.39017 30.083 1.96017 30.424C1.98917 30.401 2.02317 30.391 2.05017 30.364L13.3642 19.05C13.7542 18.659 13.7542 18.027 13.3642 17.636C12.9722 17.245 12.3402 17.245 11.9492 17.636ZM35.4222 29.04C35.4012 29.012 35.3892 28.977 35.3622 28.95L24.0502 17.636C23.6582 17.245 23.0262 17.245 22.6352 17.636C22.2442 18.028 22.2442 18.66 22.6352 19.05L33.9482 30.364C33.9742 30.39 34.0102 30.401 34.0382 30.424C34.6092 30.084 35.0822 29.61 35.4222 29.04Z"
        fill="#99AAB5"
      />
      <path
        d="M32 5H4C1.791 5 0 6.791 0 9V10.03L14.528 24.526C16.422 26.419 19.516 26.419 21.412 24.526L36 10.009V9C36 6.791 34.209 5 32 5Z"
        fill="#99AAB5"
      />
      <path
        d="M31.9993 5H3.9993C2.4113 5 1.0503 5.934 0.404297 7.275L15.1703 22.042C16.7323 23.604 19.2663 23.604 20.8273 22.042L35.5943 7.275C34.9483 5.934 33.5883 5 31.9993 5Z"
        fill="#E1E8ED"
      />
    </svg>
  );
};

export default MailIcon;
